// Co-located translations for inputs
// Registered dynamically when component loads
const inputsTranslations = {
  "en": {
    "accordion.purchaseFinancing": "Purchase & Financing",
    "accordion.startupCosts": "Acquisition Costs",
    "accordion.fixedRecurring": "Fixed Costs",
    "accordion.variableRecurring": "Variable Costs",
    "accordion.scheduledCapex": "Scheduled CapEx",
    "accordion.emergencyReserve": "Maintenance Reserve",
    "accordion.depreciation": "Depreciation (AfA)",

    "purchase.propertyPrice": "Property Purchase Price",
    "purchase.propertyPrice.tooltip": "Purchase price of the property",
    "purchase.propertyPrice.hint": "Set in Property & Revenue section above",
    "purchase.propertyPrice.disabledHint": "Set in Property & Revenue section above",
    "purchase.equityCapital": "Equity Capital",
    "purchase.equityCapital.tooltip": "Total equity capital invested",
    "purchase.debtCapital": "Mortgage Loan",
    "purchase.debtCapital.tooltip": "Mortgage loan amount",
    "purchase.interestRate": "Loan Interest Rate",
    "purchase.interestRate.tooltip": "Annual interest rate",
    "purchase.zinsbindung": "Fixed-Rate Period",
    "purchase.zinsbindung.tooltip": "Period with fixed interest rate",
    "purchase.tilgung": "Initial Repayment Rate",
    "purchase.tilgung.tooltip": "Initial annual principal repayment rate",
    "purchase.tilgungsfreieJahre": "Interest-Only Years",
    "purchase.tilgungsfreieJahre.tooltip": "Years interest-only before principal repayment begins",
    "purchase.refinancingSpread": "Refinancing Spread",
    "purchase.refinancingSpread.tooltip": "Expected interest rate change at refinancing",
    "purchase.capitalStructure": "Capital Structure",
    "purchase.totalCapitalRaised": "Total Capital",
    "purchase.ltvRatio": "LTV (Loan-to-Value)",
    "purchase.useOfFunds": "Use of Funds",
    "purchase.propertyPurchase": "Property Purchase",
    "purchase.startupCosts": "Acquisition Costs",
    "purchase.cashRemaining": "Liquidity Reserve",
    "purchase.negativeCash": "Negative liquidity! You need €{amount} more capital.",
    "purchase.annuity": "Annuity (Year 1)",
    "purchase.annuityTooltip": "Annual mortgage payment (interest + principal)",
    "purchase.loanSettings": "Loan Settings",
    "purchase.debtToEquityRatio": "Debt-to-Equity Ratio",
    "purchase.annualMortgagePayment": "Annual Mortgage Payment",
    "purchase.kaufnebenkosten": "Acquisition Costs",
    "purchase.renovationBudget": "Renovation Budget",
    "purchase.howItWorks": "How it works",
    "purchase.howItWorksText": "Your equity plus mortgage funds the purchase, acquisition costs, and renovation. The remainder stays as your liquidity reserve.",

    "startup.grunderwerbsteuer": "Property Transfer Tax",
    "startup.grunderwerbsteuer.tooltip": "Property transfer tax (varies by Bundesland)",
    "startup.notarkosten": "Notary Fees",
    "startup.notarkosten.tooltip": "Notary fees (based on GNotKG Tabelle B)",
    "startup.grundbuchkosten": "Land Registry Fees",
    "startup.grundbuchkosten.tooltip": "Land registry fees",
    "startup.maklerkosten": "Broker Commission",
    "startup.maklerkosten.tooltip": "Broker commission (buyer's share)",
    "startup.renovationBudget": "Renovation Budget",
    "startup.renovationBudget.tooltip": "Initial renovation/modernization budget",
    "startup.renovationMaintenanceShare": "Maintenance Share",
    "startup.renovationMaintenanceShare.tooltip": "Percentage of renovation classified as maintenance (not Modernisierung)",
    "startup.totalKaufnebenkosten": "Total Acquisition Costs",
    "startup.autoCalculated": "Auto-calculated from Bundesland",
    "startup.manualOverride": "Manual values used (set to 0 for auto-calculation)",
    "startup.totalInitialInvestment": "Total Initial Investment",
    "startup.kaufnebenkosten": "Acquisition Costs (Kaufnebenkosten)",
    "startup.kaufnebenkostenDesc": "Auto-calculated from Bundesland and purchase price. Enter a value > 0 to override.",
    "startup.renovation": "Renovation",
    "startup.renovationMaintenanceShareHint": "Maintenance portion is immediately deductible; the rest is capitalized (anschaffungsnahe Aufwendungen if > 15% within 3 years)",
    "startup.totalStartupCosts": "Total Initial Investment",
    "startup.overrideHint": "Override",
    "startup.overrideHintText": "Enter 0 to use the auto-calculated value based on Bundesland and purchase price.",

    "fixed.standardFixedCosts": "Fixed Costs (Annual)",
    "fixed.grundsteuer": "Property Tax",
    "fixed.grundsteuer.tooltip": "Annual property tax",
    "fixed.gebaeudeversicherung": "Building Insurance",
    "fixed.gebaeudeversicherung.tooltip": "Building insurance premium",
    "fixed.hausgeld": "Hausgeld (Monthly)",
    "fixed.hausgeld.tooltip": "Monthly WEG fee (only for apartments)",
    "fixed.hausgeldNonRecoverable": "Non-Recoverable Share",
    "fixed.hausgeldNonRecoverable.tooltip": "Percentage of Hausgeld not recoverable from tenant",
    "fixed.propertyManagement": "Property Management",
    "fixed.propertyManagement.tooltip": "Property management fee as % of rental income",
    "fixed.customFixedCosts": "Other Fixed Costs",
    "fixed.totalAnnualFixed": "Total Annual Fixed Costs",
    "fixed.hausgeldNote": "Hausgeld is only applicable for Eigentumswohnung (apartment ownership)",
    "fixed.costsOccurYearly": "These costs occur every year regardless of occupancy",
    "fixed.hausgeldAnnual": "Annual Hausgeld",
    "fixed.hausgeldNichtUmlagefaehig": "Non-Recoverable Hausgeld",
    "fixed.hausgeldNichtUmlagefaehig.tooltip": "Percentage of Hausgeld not recoverable from tenants (e.g. administration, reserve contributions)",
    "fixed.nichtUmlagefaehigAmount": "Non-recoverable amount",
    "fixed.ofRevenue": "of revenue",
    "fixed.selfManaged": "Self-managed (no management fee)",
    "fixed.professionalManagement": "Professional management",
    "fixed.customFixedTotal": "Other Fixed Costs",
    "fixed.calculatedFromRevenue": "Calculated from revenue in P&L",

    "variable.standardVariableCosts": "Variable Costs",
    "variable.description": "Variable costs scale with property value and occupancy.",
    "variable.maintenancePercent": "Maintenance Costs (% of Property Value)",
    "variable.maintenancePercent.tooltip": "Annual maintenance as % of property value",
    "variable.vacancyProvision": "Vacancy Provision",
    "variable.vacancyProvision.tooltip": "Additional annual provision for vacancy",
    "variable.tenantTurnoverCost": "Tenant Turnover Cost",
    "variable.tenantTurnoverCost.tooltip": "Cost per tenant turnover (renovation, broker, vacancy gap)",
    "variable.customVariableCosts": "Other Variable Costs",
    "variable.usingRanges": "Using ranges",
    "variable.usingRangesText": "Lower bounds represent optimistic scenarios, upper bounds pessimistic.",
    "variable.maintenanceEstimate": "Estimated annual maintenance",
    "variable.buildingValue": "Building value",
    "variable.tenantTurnoverCostHint": "Average cost per tenant change (cosmetic repairs, vacancy gap, broker fees)",
    "variable.maintenanceAnnual": "Annual Maintenance",
    "variable.perTurnover": "per turnover",

    "common.year": "Year",
    "common.month": "Month",
    "common.years": "years",
    "common.addItem": "+ Add Item",
    "common.costName": "Cost Name",
    "common.fixedPerOccurrence": "Fixed (per occurrence)",
    "common.lowerBound": "Lower Bound",
    "common.upperBound": "Upper Bound",
    "common.percentOfRevenue": "% of Revenue",

    "capex.description": "Plan major capital expenditures by year.",
    "capex.year": "Year {year}",
    "capex.itemName": "Item name",
    "capex.removeItem": "Remove item",
    "capex.addItem": "+ Add Item",
    "capex.totalScheduled": "Total Scheduled CapEx ({years} years)",
    "capex.commonCapex": "Common Capital Expenditures",
    "capex.roof": "Roof",
    "capex.roofDesc": "Roof replacement €15-60k (40 years)",
    "capex.heating": "Heating",
    "capex.heatingDesc": "Heating system €8-30k (20 years)",
    "capex.windows": "Windows",
    "capex.windowsDesc": "Window replacement €8-25k (25 years)",
    "capex.bathroom": "Bathroom",
    "capex.bathroomDesc": "Bathroom renovation €5-20k (20 years)",
    "capex.kitchen": "Kitchen",
    "capex.kitchenDesc": "Kitchen renovation €5-15k (15 years)",
    "capex.facade": "Facade",
    "capex.facadeDesc": "Facade/insulation €20-80k (30 years)",
    "capex.taxTreatment": "Tax Treatment",
    "capex.taxTreatmentText": "Capital expenditures are capitalized and depreciated. If total renovation costs exceed 15% of building value within 3 years of purchase, they become anschaffungsnahe Aufwendungen.",

    "emergency.description": "Reserve for unexpected repairs and special levies (Sonderumlagen)",
    "emergency.annualReserveRate": "Annual Reserve Rate",
    "emergency.annualReserveRate.tooltip": "% of building value set aside yearly",
    "emergency.scenario": "Scenario",
    "emergency.insuranceCovers": "Insurance Covers?",
    "emergency.reserveNeeded": "Reserve Needed?",
    "emergency.scenario1": "Sonderumlage (WEG special levy)",
    "emergency.scenario1Insurance": "No",
    "emergency.scenario1Reserve": "Yes (€2-20k)",
    "emergency.scenario2": "Mietausfall (extended vacancy)",
    "emergency.scenario2Insurance": "No",
    "emergency.scenario2Reserve": "Yes (€3-12k)",
    "emergency.scenario3": "Burst pipe / water damage",
    "emergency.scenario3Insurance": "Partially (minus deductible)",
    "emergency.scenario3Reserve": "For deductible (€1-5k)",
    "emergency.scenario4": "Heating system failure",
    "emergency.scenario4Insurance": "No (wear & tear)",
    "emergency.scenario4Reserve": "Yes (€5-30k)",
    "emergency.scenario5": "Roof leak",
    "emergency.scenario5Insurance": "Partially",
    "emergency.scenario5Reserve": "Yes (€5-20k)",
    "emergency.year1Reserve": "Year 1 Reserve Contribution",
    "emergency.approxReserve": "Estimated Reserve Buildup ({years} years)",
    "emergency.howItWorks": "How it works",
    "emergency.howItWorksText": "Each year, {percent}% of the building value is set aside.",
    "emergency.ofBuildingValue": "of building value",
    "emergency.insuranceVsReserve": "Insurance vs. Reserve",
    "emergency.buildingValue": "Building value",
    "emergency.cumulativeReserve": "Cumulative Reserve",
    "emergency.taxTreatment": "Tax Treatment",
    "emergency.taxTreatmentText": "Reserve contributions are not tax-deductible when set aside. Only actual repair costs are deductible when incurred.",
    "emergency.accrual": "Accrual Method",
    "emergency.accrualText": "Reserves accrue annually as a percentage of building value, building a buffer over time.",
    "emergency.cashReserve": "Cash Reserve",
    "emergency.cashReserveText": "Reserve is held as cash and available for emergency repairs at any time.",
    "emergency.emergencyScenarios": "Emergency Scenarios",
    "emergency.sonderumlage": "Sonderumlage (WEG special levy)",
    "emergency.sonderumlageCost": "€2,000 – €20,000",
    "emergency.mietausfall": "Mietausfall (extended vacancy)",
    "emergency.mietausfallCost": "€3,000 – €12,000",
    "emergency.burstPipe": "Burst pipe / water damage",
    "emergency.burstPipeCost": "€1,000 – €5,000 (deductible)",
    "emergency.heatingFailure": "Heating system failure",
    "emergency.heatingFailureCost": "€5,000 – €30,000",
    "emergency.roofLeak": "Roof leak",
    "emergency.roofLeakCost": "€5,000 – €20,000",
    "emergency.reserveNote": "Reserves should cover at least 2-3 months of operating costs plus one major repair.",

    "depreciation.description": "Configure depreciation (AfA) method and renovation treatment.",
    "depreciation.afaMethod": "AfA Method",
    "depreciation.afaMethodSection": "AfA Method & Rate",
    "depreciation.standard": "Standard (linear)",
    "depreciation.degressive": "Degressive (5%)",
    "depreciation.denkmalschutz": "Denkmalschutz (§7i)",
    "depreciation.currentRate": "Current AfA Rate",
    "depreciation.landBuildingSplit": "Land/Building Split",
    "depreciation.landValue": "Land Value (not depreciable)",
    "depreciation.buildingValue": "Building Value (depreciable)",
    "depreciation.renovationTreatment": "Renovation Treatment",
    "depreciation.capitalize": "Capitalize & Depreciate",
    "depreciation.capitalizeDesc": "Add to depreciable basis, depreciate over {years} years",
    "depreciation.expense": "Expense Immediately",
    "depreciation.expenseDesc": "Deduct full amount in Year 1",
    "depreciation.renovationDepreciationYears": "Renovation Depreciation Period",
    "depreciation.afaNote": "AfA rate is automatically determined from year built and method",
    "depreciation.standardRates": "Standard AfA Rates",
    "depreciation.pre1925": "Pre-1925: 2.5%",
    "depreciation.post1925": "1925-2022: 2.0%",
    "depreciation.post2022": "Post-2022: 3.0%",
    "depreciation.degressiveRate": "Degressive: 5% of residual value",
    "depreciation.denkmalschutzRate": "Denkmalschutz: 9% (years 1-8), 7% (years 9-12)",
    "depreciation.standardAfa": "Standard AfA (linear)",
    "depreciation.standardAfaText": "Fixed percentage of the original building cost, deducted annually over the useful life.",
    "depreciation.standardDesc": "Steady, predictable deduction based on year built: 2% (1925-2022), 2.5% (pre-1925), 3% (post-2022).",
    "depreciation.degressiveAfa": "Degressive AfA (5%)",
    "depreciation.degressiveAfaText": "5% of the remaining book value each year. Higher deductions early, declining over time.",
    "depreciation.degressiveDesc": "Available for new buildings (completed after 30.09.2023). Switch to linear allowed at any time.",
    "depreciation.denkmalschutzAfa": "Denkmalschutz AfA (§7i/§7h)",
    "depreciation.denkmalschutzAfaText": "Enhanced depreciation for listed/heritage buildings: 9% for years 1-8, then 7% for years 9-12.",
    "depreciation.denkmalschutzDesc": "Requires Denkmalschutzbehörde certification. Only renovation costs qualify, not the purchase price.",
    "depreciation.yearBuilt": "Year Built",
    "depreciation.setInPropertySection": "Set in Property & Revenue section",
    "depreciation.purchasePrice": "Purchase Price",
    "depreciation.landShare": "Land Share",
    "depreciation.landShareHint": "Typically 20-40% in cities, 10-20% in rural areas. Check your local Bodenrichtwert.",
    "depreciation.depreciableBuildingValue": "Depreciable Building Value",
    "depreciation.capitalizeDepreciate": "Capitalize & Depreciate",
    "depreciation.capitalizeDepreciateDesc": "Add renovation to the depreciable basis and depreciate over the specified period.",
    "depreciation.immediateExpense": "Immediate Expense",
    "depreciation.immediateExpenseDesc": "Deduct the full renovation cost as an operating expense in Year 1.",
    "depreciation.renovationDepreciationPeriod": "Renovation Depreciation Period",
    "depreciation.renovationDepreciationPeriod.tooltip": "Number of years to depreciate capitalized renovation costs (typically 15 years for substantial improvements)",
    "depreciation.bookValueProjection": "Book Value Projection",
    "depreciation.year": "Year",
    "depreciation.bookValue": "Book Value",
    "depreciation.annualDepreciation": "Annual Depreciation",
    "depreciation.germanTaxGuidelines": "German Tax Guidelines",
    "depreciation.standardAfaGuideline": "§7(4) EStG: 2% for buildings built 1925-2022, 2.5% for pre-1925, 3% for post-2022",
    "depreciation.degressiveAfaGuideline": "§7(5a) EStG: 5% degressive for new buildings completed after 30.09.2023",
    "depreciation.denkmalschutzAfaGuideline": "§7i EStG: 9% years 1-8, 7% years 9-12 for certified heritage renovation costs",
    "depreciation.anschaffungsnaheAufwendungen": "Anschaffungsnahe Aufwendungen (§6 Abs. 1 Nr. 1a EStG)",
    "depreciation.anschaffungsnaheText": "If renovation costs exceed 15% of building acquisition cost within the first 3 years, they must be capitalized (not expensed immediately).",
    "depreciation.consultWarning": "Consult a tax advisor (Steuerberater) for your specific situation.",

    "accordion.werbungskosten": "Werbungskosten (Tax Deductions)",
    "werbungskosten.description": "Additional tax-deductible expenses beyond interest and depreciation.",
    "werbungskosten.disagio": "Disagio (Loan Discount)",
    "werbungskosten.disagio.tooltip": "Upfront loan discount, deductible in Year 1 (max 5%, requires min 5-year fixed rate)",
    "werbungskosten.disagioYear1": "Year 1 deduction",
    "werbungskosten.disagioYear1OnlyLabel": "Disagio (Year 1 only)",
    "werbungskosten.steuerberater": "Tax Advisor (Steuerberater)",
    "werbungskosten.steuerberater.tooltip": "Annual tax advisor fees for rental income declaration",
    "werbungskosten.sonstige": "Other Expenses (Sonstige)",
    "werbungskosten.sonstige.tooltip": "Misc. deductible costs: account fees, travel to property, office supplies",
    "werbungskosten.mietausfallversicherung": "Rental Default Insurance",
    "werbungskosten.mietausfallversicherung.tooltip": "Insurance premium as % of annual rent",
    "werbungskosten.summary": "Summary",
    "werbungskosten.recurringAnnual": "Recurring Annual",
    "werbungskosten.totalYear1": "Total Year 1",
    "werbungskosten.infoNote": "All Werbungskosten reduce taxable rental income. Disagio requires a markt\u00fcblich rate and minimum 5-year Zinsbindung."
  },
  "de": {
    "accordion.purchaseFinancing": "Kauf & Finanzierung",
    "accordion.startupCosts": "Kaufnebenkosten",
    "accordion.fixedRecurring": "Fixkosten",
    "accordion.variableRecurring": "Variable Kosten",
    "accordion.scheduledCapex": "Geplante Investitionen",
    "accordion.emergencyReserve": "Instandhaltungsrücklage",
    "accordion.depreciation": "Abschreibungen (AfA)",

    "purchase.propertyPrice": "Immobilienkaufpreis",
    "purchase.propertyPrice.tooltip": "Kaufpreis der Immobilie",
    "purchase.propertyPrice.hint": "In der Sektion Immobilie & Einnahmen oben festgelegt",
    "purchase.propertyPrice.disabledHint": "In der Sektion Immobilie & Einnahmen oben festgelegt",
    "purchase.equityCapital": "Eigenkapitaleinlage",
    "purchase.equityCapital.tooltip": "Gesamtes eingesetztes Eigenkapital",
    "purchase.debtCapital": "Fremdkapital (Darlehen)",
    "purchase.debtCapital.tooltip": "Hypothekendarlehensbetrag",
    "purchase.interestRate": "Darlehenszinssatz",
    "purchase.interestRate.tooltip": "Jährlicher Zinssatz",
    "purchase.zinsbindung": "Zinsbindung",
    "purchase.zinsbindung.tooltip": "Zeitraum mit festem Zinssatz",
    "purchase.tilgung": "Anfängliche Tilgung",
    "purchase.tilgung.tooltip": "Anfänglicher jährlicher Tilgungssatz",
    "purchase.tilgungsfreieJahre": "Tilgungsfreie Jahre",
    "purchase.tilgungsfreieJahre.tooltip": "Jahre mit reiner Zinszahlung vor Beginn der Tilgung",
    "purchase.refinancingSpread": "Anschlussfinanzierung Aufschlag",
    "purchase.refinancingSpread.tooltip": "Erwartete Zinsänderung bei Anschlussfinanzierung",
    "purchase.capitalStructure": "Kapitalstruktur",
    "purchase.totalCapitalRaised": "Gesamtkapital",
    "purchase.ltvRatio": "LTV (Beleihungsauslauf)",
    "purchase.useOfFunds": "Mittelverwendung",
    "purchase.propertyPurchase": "Immobilienkauf",
    "purchase.startupCosts": "Kaufnebenkosten",
    "purchase.cashRemaining": "Liquiditätsreserve",
    "purchase.negativeCash": "Negative Liquidität! Sie benötigen €{amount} mehr Kapital.",
    "purchase.annuity": "Annuität (Jahr 1)",
    "purchase.annuityTooltip": "Jährliche Darlehensrate (Zinsen + Tilgung)",
    "purchase.loanSettings": "Darlehenseinstellungen",
    "purchase.debtToEquityRatio": "Fremd-/Eigenkapitalquote",
    "purchase.annualMortgagePayment": "Jährliche Darlehensrate",
    "purchase.kaufnebenkosten": "Kaufnebenkosten",
    "purchase.renovationBudget": "Renovierungsbudget",
    "purchase.howItWorks": "So funktioniert es",
    "purchase.howItWorksText": "Ihr Eigenkapital plus Darlehen finanziert den Kauf, die Kaufnebenkosten und die Renovierung. Der Rest verbleibt als Liquiditätsreserve.",

    "startup.grunderwerbsteuer": "Grunderwerbsteuer",
    "startup.grunderwerbsteuer.tooltip": "Grunderwerbsteuer (variiert nach Bundesland)",
    "startup.notarkosten": "Notarkosten",
    "startup.notarkosten.tooltip": "Notargebühren (basierend auf GNotKG Tabelle B)",
    "startup.grundbuchkosten": "Grundbuchkosten",
    "startup.grundbuchkosten.tooltip": "Grundbuchgebühren",
    "startup.maklerkosten": "Maklerkosten",
    "startup.maklerkosten.tooltip": "Maklerprovision (Käuferanteil)",
    "startup.renovationBudget": "Renovierungsbudget",
    "startup.renovationBudget.tooltip": "Budget für Erstrenovierung/Modernisierung",
    "startup.renovationMaintenanceShare": "Instandhaltungsanteil",
    "startup.renovationMaintenanceShare.tooltip": "Anteil der Renovierung, der als Instandhaltung eingestuft wird (nicht Modernisierung)",
    "startup.totalKaufnebenkosten": "Kaufnebenkosten gesamt",
    "startup.autoCalculated": "Automatisch berechnet nach Bundesland",
    "startup.manualOverride": "Manuelle Werte verwendet (auf 0 setzen für automatische Berechnung)",
    "startup.totalInitialInvestment": "Gesamte Anfangsinvestition",
    "startup.kaufnebenkosten": "Kaufnebenkosten",
    "startup.kaufnebenkostenDesc": "Automatisch berechnet nach Bundesland und Kaufpreis. Wert > 0 eingeben zum Überschreiben.",
    "startup.renovation": "Renovierung",
    "startup.renovationMaintenanceShareHint": "Der Instandhaltungsanteil ist sofort absetzbar; der Rest wird aktiviert (anschaffungsnahe Aufwendungen wenn > 15% innerhalb von 3 Jahren)",
    "startup.totalStartupCosts": "Gesamte Anfangsinvestition",
    "startup.overrideHint": "Überschreiben",
    "startup.overrideHintText": "0 eingeben, um den automatisch berechneten Wert basierend auf Bundesland und Kaufpreis zu verwenden.",

    "fixed.standardFixedCosts": "Fixkosten (jährlich)",
    "fixed.grundsteuer": "Grundsteuer",
    "fixed.grundsteuer.tooltip": "Jährliche Grundsteuer",
    "fixed.gebaeudeversicherung": "Gebäudeversicherung",
    "fixed.gebaeudeversicherung.tooltip": "Gebäudeversicherungsprämie",
    "fixed.hausgeld": "Hausgeld (monatlich)",
    "fixed.hausgeld.tooltip": "Monatlicher WEG-Beitrag (nur bei Eigentumswohnungen)",
    "fixed.hausgeldNonRecoverable": "Nicht-umlagefähiger Anteil",
    "fixed.hausgeldNonRecoverable.tooltip": "Anteil des Hausgeldes, der nicht auf den Mieter umgelegt werden kann",
    "fixed.propertyManagement": "Hausverwaltung",
    "fixed.propertyManagement.tooltip": "Hausverwaltungsgebühr als % der Mieteinnahmen",
    "fixed.customFixedCosts": "Sonstige Fixkosten",
    "fixed.totalAnnualFixed": "Jährliche Fixkosten gesamt",
    "fixed.hausgeldNote": "Hausgeld gilt nur für Eigentumswohnungen",
    "fixed.costsOccurYearly": "Diese Kosten fallen jährlich an, unabhängig von der Vermietung",
    "fixed.hausgeldAnnual": "Jährliches Hausgeld",
    "fixed.hausgeldNichtUmlagefaehig": "Nicht-umlagefähiges Hausgeld",
    "fixed.hausgeldNichtUmlagefaehig.tooltip": "Anteil des Hausgeldes, der nicht auf Mieter umgelegt werden kann (z.B. Verwaltung, Rücklagenbeiträge)",
    "fixed.nichtUmlagefaehigAmount": "Nicht-umlagefähiger Betrag",
    "fixed.ofRevenue": "vom Umsatz",
    "fixed.selfManaged": "Selbstverwaltet (keine Verwaltungsgebühr)",
    "fixed.professionalManagement": "Professionelle Verwaltung",
    "fixed.customFixedTotal": "Sonstige Fixkosten",
    "fixed.calculatedFromRevenue": "Berechnet aus den Mieteinnahmen",

    "variable.standardVariableCosts": "Variable Kosten",
    "variable.description": "Variable Kosten skalieren mit dem Immobilienwert und der Auslastung.",
    "variable.maintenancePercent": "Instandhaltungskosten (% vom Immobilienwert)",
    "variable.maintenancePercent.tooltip": "Jährliche Instandhaltung als % des Immobilienwerts",
    "variable.vacancyProvision": "Mietausfallrücklage",
    "variable.vacancyProvision.tooltip": "Zusätzliche jährliche Rücklage für Leerstand",
    "variable.tenantTurnoverCost": "Mieterwechselkosten",
    "variable.tenantTurnoverCost.tooltip": "Kosten pro Mieterwechsel (Renovierung, Makler, Leerstandslücke)",
    "variable.customVariableCosts": "Sonstige variable Kosten",
    "variable.usingRanges": "Verwendung von Spannen",
    "variable.usingRangesText": "Untergrenzen stellen optimistische Szenarien dar, Obergrenzen pessimistische.",
    "variable.maintenanceEstimate": "Geschätzte jährliche Instandhaltung",
    "variable.buildingValue": "Gebäudewert",
    "variable.tenantTurnoverCostHint": "Durchschnittliche Kosten pro Mieterwechsel (Schönheitsreparaturen, Leerstandslücke, Maklergebühren)",
    "variable.maintenanceAnnual": "Jährliche Instandhaltung",
    "variable.perTurnover": "pro Mieterwechsel",

    "common.year": "Jahr",
    "common.month": "Monat",
    "common.years": "Jahre",
    "common.addItem": "+ Hinzufügen",
    "common.costName": "Kostenbezeichnung",
    "common.fixedPerOccurrence": "Fest (pro Ereignis)",
    "common.lowerBound": "Untergrenze",
    "common.upperBound": "Obergrenze",
    "common.percentOfRevenue": "% vom Umsatz",

    "capex.description": "Planen Sie größere Investitionen nach Jahr.",
    "capex.year": "Jahr {year}",
    "capex.itemName": "Bezeichnung",
    "capex.removeItem": "Entfernen",
    "capex.addItem": "+ Hinzufügen",
    "capex.totalScheduled": "Geplante Investitionen gesamt ({years} Jahre)",
    "capex.commonCapex": "Häufige Investitionen",
    "capex.roof": "Dach",
    "capex.roofDesc": "Dacherneuerung €15-60k (40 Jahre)",
    "capex.heating": "Heizung",
    "capex.heatingDesc": "Heizungsanlage €8-30k (20 Jahre)",
    "capex.windows": "Fenster",
    "capex.windowsDesc": "Fenstererneuerung €8-25k (25 Jahre)",
    "capex.bathroom": "Badezimmer",
    "capex.bathroomDesc": "Badsanierung €5-20k (20 Jahre)",
    "capex.kitchen": "Küche",
    "capex.kitchenDesc": "Küchenrenovierung €5-15k (15 Jahre)",
    "capex.facade": "Fassade",
    "capex.facadeDesc": "Fassade/Dämmung €20-80k (30 Jahre)",
    "capex.taxTreatment": "Steuerliche Behandlung",
    "capex.taxTreatmentText": "Investitionsausgaben werden aktiviert und abgeschrieben. Übersteigen die Renovierungskosten innerhalb von 3 Jahren nach Kauf 15% des Gebäudewertes, werden sie zu anschaffungsnahen Aufwendungen.",

    "emergency.description": "Rücklage für unerwartete Reparaturen und Sonderumlagen",
    "emergency.annualReserveRate": "Jährliche Rücklagenquote",
    "emergency.annualReserveRate.tooltip": "% des Gebäudewerts jährlich zurückgelegt",
    "emergency.scenario": "Szenario",
    "emergency.insuranceCovers": "Versicherung deckt?",
    "emergency.reserveNeeded": "Reserve benötigt?",
    "emergency.scenario1": "Sonderumlage (WEG-Sonderumlage)",
    "emergency.scenario1Insurance": "Nein",
    "emergency.scenario1Reserve": "Ja (€2-20k)",
    "emergency.scenario2": "Mietausfall (längerer Leerstand)",
    "emergency.scenario2Insurance": "Nein",
    "emergency.scenario2Reserve": "Ja (€3-12k)",
    "emergency.scenario3": "Rohrbruch / Wasserschaden",
    "emergency.scenario3Insurance": "Teilweise (abzgl. Selbstbeteiligung)",
    "emergency.scenario3Reserve": "Für Selbstbeteiligung (€1-5k)",
    "emergency.scenario4": "Heizungsausfall",
    "emergency.scenario4Insurance": "Nein (Verschleiß)",
    "emergency.scenario4Reserve": "Ja (€5-30k)",
    "emergency.scenario5": "Dachundichtigkeit",
    "emergency.scenario5Insurance": "Teilweise",
    "emergency.scenario5Reserve": "Ja (€5-20k)",
    "emergency.year1Reserve": "Rücklagenbeitrag Jahr 1",
    "emergency.approxReserve": "Geschätzte Rücklagenbildung ({years} Jahre)",
    "emergency.howItWorks": "So funktioniert es",
    "emergency.howItWorksText": "Jedes Jahr werden {percent}% des Gebäudewerts zurückgelegt.",
    "emergency.ofBuildingValue": "vom Gebäudewert",
    "emergency.insuranceVsReserve": "Versicherung vs. Rücklage",
    "emergency.buildingValue": "Gebäudewert",
    "emergency.cumulativeReserve": "Kumulierte Rücklage",
    "emergency.taxTreatment": "Steuerliche Behandlung",
    "emergency.taxTreatmentText": "Rücklagenbeiträge sind bei Bildung nicht steuerlich absetzbar. Nur tatsächliche Reparaturkosten sind bei Anfall absetzbar.",
    "emergency.accrual": "Ansparmethode",
    "emergency.accrualText": "Rücklagen werden jährlich als Prozentsatz des Gebäudewerts angespart und bilden über die Zeit einen Puffer.",
    "emergency.cashReserve": "Barreserve",
    "emergency.cashReserveText": "Die Rücklage wird als Bargeld gehalten und steht jederzeit für Notfallreparaturen zur Verfügung.",
    "emergency.emergencyScenarios": "Notfallszenarien",
    "emergency.sonderumlage": "Sonderumlage (WEG-Sonderumlage)",
    "emergency.sonderumlageCost": "€2.000 – €20.000",
    "emergency.mietausfall": "Mietausfall (längerer Leerstand)",
    "emergency.mietausfallCost": "€3.000 – €12.000",
    "emergency.burstPipe": "Rohrbruch / Wasserschaden",
    "emergency.burstPipeCost": "€1.000 – €5.000 (Selbstbeteiligung)",
    "emergency.heatingFailure": "Heizungsausfall",
    "emergency.heatingFailureCost": "€5.000 – €30.000",
    "emergency.roofLeak": "Dachundichtigkeit",
    "emergency.roofLeakCost": "€5.000 – €20.000",
    "emergency.reserveNote": "Rücklagen sollten mindestens 2-3 Monate Betriebskosten plus eine größere Reparatur abdecken.",

    "depreciation.description": "AfA-Methode und Renovierungsbehandlung konfigurieren.",
    "depreciation.afaMethod": "AfA-Methode",
    "depreciation.afaMethodSection": "AfA-Methode & Satz",
    "depreciation.standard": "Standard (linear)",
    "depreciation.degressive": "Degressiv (5%)",
    "depreciation.denkmalschutz": "Denkmalschutz (§7i)",
    "depreciation.currentRate": "Aktueller AfA-Satz",
    "depreciation.landBuildingSplit": "Grund/Gebäude-Aufteilung",
    "depreciation.landValue": "Grundstückswert (nicht abschreibbar)",
    "depreciation.buildingValue": "Gebäudewert (abschreibbar)",
    "depreciation.renovationTreatment": "Renovierungsbehandlung",
    "depreciation.capitalize": "Aktivieren & Abschreiben",
    "depreciation.capitalizeDesc": "Zur Abschreibungsbasis hinzufügen, über {years} Jahre abschreiben",
    "depreciation.expense": "Sofort aufwanden",
    "depreciation.expenseDesc": "Voller Betrag in Jahr 1 absetzen",
    "depreciation.renovationDepreciationYears": "Abschreibungsdauer Renovierung",
    "depreciation.afaNote": "Der AfA-Satz wird automatisch aus Baujahr und Methode bestimmt",
    "depreciation.standardRates": "Standard AfA-Sätze",
    "depreciation.pre1925": "Vor 1925: 2,5%",
    "depreciation.post1925": "1925-2022: 2,0%",
    "depreciation.post2022": "Nach 2022: 3,0%",
    "depreciation.degressiveRate": "Degressiv: 5% vom Restwert",
    "depreciation.denkmalschutzRate": "Denkmalschutz: 9% (Jahre 1-8), 7% (Jahre 9-12)",
    "depreciation.standardAfa": "Standard AfA (linear)",
    "depreciation.standardAfaText": "Fester Prozentsatz der ursprünglichen Gebäudekosten, jährlich über die Nutzungsdauer abgezogen.",
    "depreciation.standardDesc": "Gleichmäßige, planbare Abschreibung nach Baujahr: 2% (1925-2022), 2,5% (vor 1925), 3% (nach 2022).",
    "depreciation.degressiveAfa": "Degressive AfA (5%)",
    "depreciation.degressiveAfaText": "5% des verbleibenden Buchwerts pro Jahr. Höhere Abschreibungen am Anfang, abnehmend über die Zeit.",
    "depreciation.degressiveDesc": "Verfügbar für Neubauten (fertiggestellt nach 30.09.2023). Wechsel zu linear jederzeit möglich.",
    "depreciation.denkmalschutzAfa": "Denkmalschutz-AfA (§7i/§7h)",
    "depreciation.denkmalschutzAfaText": "Erhöhte Abschreibung für denkmalgeschützte Gebäude: 9% für Jahre 1-8, dann 7% für Jahre 9-12.",
    "depreciation.denkmalschutzDesc": "Erfordert Bescheinigung der Denkmalschutzbehörde. Nur Sanierungskosten qualifizieren sich, nicht der Kaufpreis.",
    "depreciation.yearBuilt": "Baujahr",
    "depreciation.setInPropertySection": "In der Sektion Immobilie & Einnahmen festgelegt",
    "depreciation.purchasePrice": "Kaufpreis",
    "depreciation.landShare": "Grundstücksanteil",
    "depreciation.landShareHint": "Typisch 20-40% in Städten, 10-20% im ländlichen Raum. Prüfen Sie Ihren lokalen Bodenrichtwert.",
    "depreciation.depreciableBuildingValue": "Abschreibbarer Gebäudewert",
    "depreciation.capitalizeDepreciate": "Aktivieren & Abschreiben",
    "depreciation.capitalizeDepreciateDesc": "Renovierung zur Abschreibungsbasis hinzufügen und über den angegebenen Zeitraum abschreiben.",
    "depreciation.immediateExpense": "Sofort aufwanden",
    "depreciation.immediateExpenseDesc": "Gesamte Renovierungskosten als Betriebsaufwand in Jahr 1 absetzen.",
    "depreciation.renovationDepreciationPeriod": "Abschreibungsdauer Renovierung",
    "depreciation.renovationDepreciationPeriod.tooltip": "Anzahl der Jahre zur Abschreibung aktivierter Renovierungskosten (typisch 15 Jahre für wesentliche Verbesserungen)",
    "depreciation.bookValueProjection": "Buchwertprojektion",
    "depreciation.year": "Jahr",
    "depreciation.bookValue": "Buchwert",
    "depreciation.annualDepreciation": "Jährliche Abschreibung",
    "depreciation.germanTaxGuidelines": "Deutsche Steuerrichtlinien",
    "depreciation.standardAfaGuideline": "§7(4) EStG: 2% für Gebäude 1925-2022, 2,5% vor 1925, 3% nach 2022",
    "depreciation.degressiveAfaGuideline": "§7(5a) EStG: 5% degressiv für Neubauten fertiggestellt nach 30.09.2023",
    "depreciation.denkmalschutzAfaGuideline": "§7i EStG: 9% Jahre 1-8, 7% Jahre 9-12 für zertifizierte Denkmal-Sanierungskosten",
    "depreciation.anschaffungsnaheAufwendungen": "Anschaffungsnahe Aufwendungen (§6 Abs. 1 Nr. 1a EStG)",
    "depreciation.anschaffungsnaheText": "Übersteigen Renovierungskosten innerhalb der ersten 3 Jahre 15% der Gebäude-Anschaffungskosten, müssen sie aktiviert werden (nicht sofort absetzbar).",
    "depreciation.consultWarning": "Konsultieren Sie einen Steuerberater f\u00fcr Ihre individuelle Situation.",

    "accordion.werbungskosten": "Werbungskosten",
    "werbungskosten.description": "Zus\u00e4tzliche steuerlich absetzbare Ausgaben \u00fcber Zinsen und AfA hinaus.",
    "werbungskosten.disagio": "Disagio (Damnum)",
    "werbungskosten.disagio.tooltip": "Darlehensabschlag, sofort absetzbar in Jahr 1 (max 5%, Zinsbindung mind. 5 Jahre)",
    "werbungskosten.disagioYear1": "Abzug in Jahr 1",
    "werbungskosten.disagioYear1OnlyLabel": "Disagio (nur Jahr 1)",
    "werbungskosten.steuerberater": "Steuerberater",
    "werbungskosten.steuerberater.tooltip": "J\u00e4hrliche Steuerberaterkosten f\u00fcr die Mieteinnahmenerkl\u00e4rung",
    "werbungskosten.sonstige": "Sonstige Aufwendungen",
    "werbungskosten.sonstige.tooltip": "Sonstige absetzbare Kosten: Kontof\u00fchrung, Fahrten zum Objekt, B\u00fcrobedarf",
    "werbungskosten.mietausfallversicherung": "Mietausfallversicherung",
    "werbungskosten.mietausfallversicherung.tooltip": "Versicherungspr\u00e4mie als % der Jahresmiete",
    "werbungskosten.summary": "\u00dcbersicht",
    "werbungskosten.recurringAnnual": "J\u00e4hrlich wiederkehrend",
    "werbungskosten.totalYear1": "Gesamt Jahr 1",
    "werbungskosten.infoNote": "Alle Werbungskosten mindern die zu versteuernden Mieteinnahmen. Disagio erfordert einen markt\u00fcblichen Satz und mindestens 5 Jahre Zinsbindung."
  }
};

export default inputsTranslations;
